// src/utils/roles.js

export const ROLES = {
  SUPERUSER: 'SUPERUSER',
  PARTNER: 'PARTNER',
  ASSOCIATE: 'ASSOCIATE',
  PARALEGAL: 'PARALEGAL',
  SUPPORT_STAFF: 'SUPPORT_STAFF',
  BOARD_MEMBER: 'BOARD_MEMBER',
  CLIENT: 'CLIENT', // Assuming clients might have a role
};
